function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withModifiers } from '../../decorators';
import { ContextNested, getValidNestedChild } from '../../hooks/context-nested';

var Text = function Text(_ref) {
  var allowi18nhtml = _ref.allowi18nhtml,
      Tag = _ref.asTag,
      children = _ref.children,
      className = _ref.className,
      content = _ref.content,
      others = _objectWithoutProperties(_ref, ["allowi18nhtml", "asTag", "children", "className", "content"]);

  /* Allows component to display 'string' as primitive type or Object type */
  var child = content || children;
  child = child && typeof child.valueOf() === 'string' ? child.valueOf() : child;
  var props = content && allowi18nhtml ? {
    dangerouslySetInnerHTML: {
      __html: content
    }
  } : {
    children: child
  };
  var notText = className.match(/(control|field)/g);

  var _contextNested = useContext(ContextNested);

  var _Tag = getValidNestedChild(_contextNested.isNestedInParent, Tag);

  var classes = classNames({
    'text': !notText
  }, {
    'is-p-like': Tag === 'div' && !notText
  }, className);
  return React.createElement(ContextNested.Provider, {
    value: {
      isNestedInParent: _Tag,
      isNestedInlink: Tag === 'a'
    }
  }, React.createElement(_Tag, _extends({}, others, props, {
    className: classes
  })));
};

Text.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  asTag: PropTypes.string,
  content: PropTypes.any,
  allowi18nhtml: PropTypes.bool
};
Text.defaultProps = {
  asTag: 'p'
};
export default withModifiers(Text);